@if (!isSensitive)
{
<p-inputMask #maskedInput
	[autoClear]="true"
	[mask]="field.props.mask"
	[styleClass]="inputStyleClass"
	[formControl]="formControl"
	[formlyAttributes]="field"
	[placeholder]="field.props.placeholder"
	[ariaLabel]="field.props.label">
</p-inputMask>
}
@else
{
<div class="custom-sensitive-input">
	<p-inputMask *ngIf="isRevealed()"
		#sensitiveInput
		[autoClear]="true"
		[mask]="field.props.mask"
		[styleClass]="inputStyleClass"
		[formControl]="formControl"
		[formlyAttributes]="field"
		[placeholder]="field.props.placeholder"
		[class]="'sensitive-input'"
		[ariaLabel]="field.props.label"
		(onBlur)="handleBlur($event)">
	</p-inputMask>

	<input *ngIf="!isRevealed()"
		pInputText
		[id]="field.id"
		type="text"
		[value]="getMaskedValue()"
		[class]="['sensitive-input', 'sensitive-masked-input', inputStyleClass]"
		[formlyAttributes]="field"
		[disabled]="isDisabled"
		readonly="true"
		tabindex="-1"
		(click)="revealSensitiveValue()">

	<button *ngIf="canToggleVisibility"
		#toggleButton
		type="button"
		class="sensitive-toggle-button p-button p-component p-button-text"
		[attr.aria-label]="isRevealed() ? 'Hide value' : 'Show value'"
		(mousedown)="onToggleMouseDown()"
		(click)="toggleVisibility()">
		<i class="pi"
			[ngClass]="isRevealed() ? 'pi-eye-slash' : 'pi-eye'">
		</i>
	</button>
</div>
}

<field-validation-message [field]="field">
</field-validation-message>